import { Link } from 'react-router-dom'
import Button from '../Button'
import Icon from '../Icon'
import Reveal from '../Reveal'
import { Section } from '../Section'

/**
 * "Warum ist eine professionelle Hausverwaltung wichtig?"
 *
 * On the old site this was a heading, a "Mehr Infos" button and nothing else -
 * the body copy had either never been written or was lost with the Elementor
 * data. The four points are condensed from CASA's own article on professional
 * Mietverwaltung, which is linked at the end so the source is one click away.
 */

const POINTS = [
  {
    icon: 'users',
    title: 'Optimierte Vermietungsprozesse',
    text: 'Zuverlässige Mieter werden sorgfältig ausgewählt und geprüft. Das senkt das Risiko von Zahlungsausfällen und Mietstreitigkeiten.',
  },
  {
    icon: 'scale',
    title: 'Rechtliche Gewissheit',
    text: 'Das Mietrecht ändert sich regelmäßig. Wir halten Ihre Mietverhältnisse auf dem aktuellen Stand und vermeiden so teure Auseinandersetzungen.',
  },
  {
    icon: 'wrench',
    title: 'Wartung und Instandhaltung',
    text: 'Reparaturen werden geplant, überwacht und koordiniert - für den Werterhalt des Objekts und die Zufriedenheit der Bewohner.',
  },
  {
    icon: 'chart',
    title: 'Transparente Buchführung',
    text: 'Detaillierte Abrechnungen für Eigentümer und Mieter schaffen finanzielle Klarheit, bevor Meinungsverschiedenheiten entstehen.',
  },
]

export default function WhyProfessional() {
  return (
    <Section tone="paper">
      <div className="split split--copy-narrow">
        <Reveal>
          <p className="eyebrow">Warum überhaupt eine Verwaltung?</p>
          <h2 style={{ marginTop: 'var(--s-4)' }}>
            Warum ist eine professionelle Hausverwaltung wichtig?
          </h2>
          <p
            style={{
              marginTop: 'var(--s-5)',
              fontSize: 'var(--step-1)',
              lineHeight: 1.6,
            }}
          >
            Vermieten besteht aus vielen Einzelaufgaben - Mieterauswahl,
            Abrechnung, Reparaturen, Fristen. Jede einzelne ist beherrschbar,
            alle zusammen kosten Zeit und bergen Risiken. Eine Verwaltung nimmt
            Ihnen die Aufgaben ab und trägt die Verantwortung mit.
          </p>
          <div className="btn-row" style={{ marginTop: 'var(--s-6)' }}>
            <Button to="/verwalten" icon="arrowRight">
              Mehr Infos
            </Button>
          </div>
          <p style={{ marginTop: 'var(--s-5)', fontSize: 'var(--step--1)' }}>
            Ausführlich nachzulesen in unserem Beitrag{' '}
            <Link to="/insights/wie-eine-professionelle-mietverwaltung-die-zufriedenheit-der-vermieter-und-mieter-steigert">
              „Wie eine professionelle Mietverwaltung die Zufriedenheit der
              Vermieter und Mieter steigert“
            </Link>
            .
          </p>
        </Reveal>

        <Reveal group className="grid grid--2">
          {POINTS.map((item) => (
            <article className="card feature" key={item.title}>
              <span className="icon-tile">
                <Icon name={item.icon} />
              </span>
              <h3 className="feature__title">{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </Reveal>
      </div>
    </Section>
  )
}
